module.exports = __webpack_public_path__ + "static/media/sensori.283d1f1b.png";